/* eslint-disable */
import { PermissionEnum } from '@creditsights/api-ui-web';
import { ICONS } from '@creditsights/styleguide-web';

export const GENERIC_ERROR_TEXT = 'Oops! Something went wrong. Please try again';
export const NO_DATA = '—';

export const SUPPORTED_ROUTES = ['/company-list', '/analysts', '/data-tools', '/deals-pipeline', '/market-stats', '/user', '/callback', '/disclaimer'];

export const ACCESS_TOKEN_NAME = 'csci-access-token';
export const REFRESH_TOKEN_NAME = 'csci-refresh-token';

export const ONBOARDING_WATCHLIST_NAME = 'Onboarding Watchlist';

export const DEFAULT_SUBSCRIPTIONS_EMAIL_ADDRESS = 'subscriptions@creditsights.com';

export const COMPANY_SUGGESTIONS_CACHE_KEY = 'company-suggestions';
export const COMPANY_FILTERS_CACHE_KEY = 'company-filters';
export const MARKETS_CACHE_KEY = 'markets';
export const MARKET_STATS_CACHE_KEY = 'market-stats';
export const USER_INTERESTS_CACHE_KEY = 'user-account-interests';
export const ONBOARDING_WATCHLIST_CACHE_KEY = 'onboarding-watchlist';
export const USER_PROFILE_CACHE_KEY = 'user-account-profile';
export const USER_ROLES_CACHE_KEY = 'user-account-roles';
export const USER_PERMISSIONS_CACHE_KEY = 'user-account-permissions';
export const USER_CONSENTS_KEY = 'user-account-user-consents';

export const USER_WATCHLISTS_KEY = 'user-watchlists';
export const USER_EMAIL_PREFERENCES_CACHE_KEY = 'user-email-preferences';
export const COUNTRIES_CACHE_KEY = 'countries';
export const COUNTRY_STATES_CACHE_KEY = 'country-states';
export const ANALYSTS_CACHE_KEY = 'analysts';
export const ANALYST_COVERAGE_CACHE_KEY = 'analyst-coverage';
export const ARTICLES_CACHE_KEY = 'articles';
export const COMPANIES_CACHE_KEY = 'analyst-coverage';
export const LOAN_COMPARE_FILTER_CACHE_KEY = 'loan-compare-filters';
export const COVENANT_COMPARE_FILTER_CACHE_KEY = 'covenant-compare-filters';
export const BOND_SEARCH_FILTER_CACHE_KEY = 'bond-search-filters';
export const SECURITY_FILTER_CACHE_KEY = 'security-filters';
export const LOAN_COMPARE_DATA_CACHE_KEY = 'loan-compare-data';
export const COVENANT_COMPARE_DATA_CACHE_KEY = 'covenant-compare-data';
export const BOND_SEARCH_DATA_CACHE_KEY = 'bond-search-data';
export const LOAN_COMPARE_DETAILS_DATA_CACHE_KEY = 'loan-compare-details-data';
export const COVENANT_COMPARE_DETAILS_DATA_CACHE_KEY = 'covenant-compare-details-data';
export const SECURITIES_CACHE_KEY = 'securities';
export const SNIPPETS_CACHE_KEY = 'snippets';

export const DISCLAIMER_ROUTE = '/disclaimer';

export const GENERAL_TOPICS = 'General Topics';

export const USER_ONBOARDING_ROUTE = '/user/onboarding';
export const USER_PROFILE_ROUTE = '/user/profile';
export const EMAIL_PREFERENCES_ROUTE = '/user/email-preferences';
export const COMPLIANCE_AND_CONSENT_ROUTE = '/user/compliance-and-consent';
export const ANALYSTS_ROUTE = '/analysts';
export const ANALYST_ROUTE = '/analysts/:analystId';
export const DATA_TOOLS_ROUTE = '/data-tools';
export const DOCUMENT_SEARCH_ROUTE = (docType: string) => `/data-tools/${docType}-search`;
export const DOCUMENT_SEARCH_ALL_ROUTE = (docType: string) => `/data-tools/${docType}-search/all`;
export const DOCUMENT_SEARCH_REPORTS_ROUTE = (docType: string) => `/data-tools/${docType}-search/reports`;
export const DOCUMENT_SEARCH_SOURCE_DOCUMENTS_ROUTE = (docType: string) => `/data-tools/${docType}-search/source-documents`;
export const LOAN_COMPARE_ROUTE = '/data-tools/loan-compare';
export const LOAN_COMPARE_DETAILS_ROUTE = '/data-tools/loan-compare/details';
export const COVENANT_COMPARE_DETAILS_ROUTE = '/data-tools/bond-compare/details';
export const COVENANT_COMPARE_ROUTE = '/data-tools/bond-compare';
export const DOC_SCORES_US_ROUTE = '/data-tools/doc-score/us';
export const DOC_SCORES_EU_ROUTE = '/data-tools/doc-score/eu';
export const DEALS_PIPELINE_BONDS_ROUTE = '/deals-pipeline/bond';
export const DEALS_PIPELINE_LOANS_ROUTE = '/deals-pipeline/loans';
export const DEALS_PIPELINE_COMBINED_ROUTE = '/deals-pipeline/combined';
export const MARKET_STATS_LOANS_ROUTE = '/market-stats/loans';
export const MARKET_STATS_BONDS_ROUTE = '/market-stats/bonds';
export const MARKET_STATS_SPECIAL_SITUATIONS_ROUTE = '/market-stats/special-situation';
export const MARKET_STATS_STRUCTURED_FINANCE_ROUTE = '/market-stats/structured-finance';
export const NOT_FOUND = '/404';

export const TAG_TYPES = {
  country: 'country',
};

export const CONSENT_MAPPER = {
  PrivacyPolicy: 'Privacy Policy',
  TermsAndConditions: 'Terms of use',
  Marketing: 'Marketing Policy',
};

export const WEIGHTING_ICONS_MAP = {
  buy: ICONS.Buy,
  hold: ICONS.Hold,
  marketperform: ICONS.Marketperform,
  norecommendation: ICONS.Norecommendation,
  outperform: ICONS.Outperform,
  sell: ICONS.Sell,
  underperform: ICONS.Underperform,
};

export const COVERAGE_KEYS = {
  cs: 'cs',
  cr: 'cr',
  lfi: 'lfi',
  financials: 'financials',
};

export const CS_VIEW_DATA = [
  {
    key: 'Buy',
    title: 'Buy',
  },
  {
    key: 'Outperform',
    title: 'Outperform',
  },
  {
    key: 'Marketperform',
    title: 'Market perform',
  },
  {
    key: 'Hold',
    title: 'Hold',
  },
  {
    key: 'Underperform',
    title: 'Underperform',
  },
  {
    key: 'Sell',
    title: 'Sell',
  },
  {
    key: 'NoRecommendation',
    title: 'No Recommendation',
  },
];

export const ICON_MAP = {
  pdf: 'Pdf',
  xlsx: 'Xlsx',
  xlsm: 'Xlsx',
  ppt: 'Pptx',
  pptx: 'Pptx',
  pptm: 'Pptx',
};

export const DOC_SCORE_EU_SLIDES = [
  {
    active: true,
    title: 'Documentation Scoring Overview',
    content: `
      <div id="slide_1">
        <ul>
            <li><span class="bold">Goal:</span> Measure the strength of the document to protecting lenders’ position</li>
            <li><span class="bold">Format:</span> 1 (strongest) to 5 (weakest) scale with pluses and minuses applied for more precision</li>
            <li><span class="bold">Scores:</span> CR will provide one overarching Composite Score that is derived from six Sub-Scores, based on a proprietary weighting scale</li>
            <li>
                <span class="bold">Sub-scores:</span>
                <ul>
                    <li>Collateral Protection</li>
                    <li>Default Protection</li>
                    <li>Lender’s Repricing Optionality</li>
                    <li>Liquidity Protection</li>
                    <li>Reporting Protection</li>
                    <li>Junior Debt Prepayments (JDP) Protection</li>
                </ul>
            </li>
            <li><span class="bold">Coverage:</span> Covenant Review will provide Documentation Scores
                for preliminary and final versions of European Senior Secured Institutional loans in its data sample
            </li>
            <li><span class="bold">Note:</span> Documentation Scores address the strength of the document’s ability to protect lenders.
                They are not meant to indicate recovery or default probabilities based on a
                borrower’s pro forma balance sheet / cash flow statement or financial performance over time
            </li>

        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring Overview: Definitions',
    content: `
      <div id="slide_2" class="content-block hidden">
        For each loan, Covenant Review provides one overarching <strong>Composite Score</strong> that is based on the following six sub-scores:
        <ul>
            <li>
                <span class="bold">Collateral Protection: </span>
                Measures how well the document protects lenders’ collateral position from,
                among other things, leakage of assets from the collateral pool,
                or the addition of new first-lien debt secured by a lien on the same assets
            </li>
            <li><span class="bold">Default Protection: </span> Measures how well the document reduces default risk
                by limiting the borrower’s ability to increase balance sheet leverage
            </li>
            <li><span class="bold">Lenders’ Repricing Optionality:
                </span> Measures lenders’ ability to increase spreads or garner fees if the issuer’s
                financial position deteriorates or it takes corporate actions such as a change of control
            </li>
            <li><span class="bold">Liquidity Protection: </span> Measures lenders’ ability to trade out of a credit</li>
            <li><span class="bold">Reporting Protection: </span> Measures lenders’ rights to receive regular financial (and other) information from the borrower</li>
            <li><span class="bold">JDP Protection:  </span> Measures how well the document protects senior secured lenders’ right to be prepaid first</li>
        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring Overview: Method',
    content: `
      <div id="slide_3" class="content-block hidden">
        Each Score will be a product of multiple inputs comprising:
        <ul>
            <li>
                <span class="bold">Quality Scores:</span> For key document categories that cannot be measured only on an empirical basis:
                <ul>
                    <li>EBITDA Adjustment Definition Quality Score</li>
                    <li>Builder Basket Quality Score</li>
                    <li>Amendments Quality Score</li>
                    <li>Mandatory Prepayments Quality Score</li>
                    <li>Junior Debt Prepayments Quality Score</li>
                    <li>Structural Subordination Quality Score</li>
                    <li>Reporting Quality Score</li>
                    <li>Transfer Provisions Quality Score</li>
                </ul>
            </li>
            <li>
                <span class="bold">Empirical data:</span> Such as free-and-clear (F&amp;C) tranche size as a percentage of EBITDA;
                leakage of assets from the collateral pool; basket caps / growers; portability; MFN carve-outs; etc.
            </li>
            <li>
                <span class="bold"> Lawyer Judgment:</span> The scores are calibrated by qualitative assessments
                from CR’s team of legal analysts, all of whom are practicing lawyers with many years’ experience crafting LevFin documents
            </li>
        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Collateral Protection Sub-Score',
    content: `
      <div id="slide_4" class="content-block hidden">
        Addresses the paramount purpose of the credit agreement: keeping lenders’ recovery high in the event of a default
        <ul>
            <li>
                <span class="bold">Empirical inputs:</span>  Free-and-clear* hard-cap amount; free-and-clear grower percent;
                cap on investments in unrestricted subsidiaries; pass-through investment basket (aka J Crew Trapdoor provision);
                asset sales sweep step-downs; reinvestment rights; inside maturity carve-out; structural subordination
                (guarantor coverage and material subsidiary definition); and single point of enforcement
            </li>
            <li><span class="bold">Qualitative inputs:</span>  Adjusted EBITDA Quality Score and Mandatory Prepayments Quality Score</li>
        </ul>
        <br>
        <span class="red_star">*</span>  “Free-and-clear” refers to the euro-capped portion of the incremental facility. Use of the free-and-clear     amount does not require compliance with a ratio test
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Default Protection Sub-Score',
    content: `
      <div id="slide_5" class="content-block hidden">
        Addresses the issuer’s ability to add debt to the balance sheet or reduce equity, and thereby increase the issuer’s default risk profile

        <ul>
            <li>
                <span class="bold">Empirical inputs:</span> General debt purpose cap (inclusive of all debt capacity);
                restricted payment cap; and structural subordination (guarantor coverage and material subsidiary definition)
            </li>
            <li>
                <span class="bold">Qualitative inputs:</span> Adjusted EBITDA Quality Score;
                Builder Basket Quality Score; and Structural Subordination Quality Score
            </li>
        </ul>
    </div>
    `,
  },
  {
    title: "Documentation Scoring: Lenders' Repricing Optionality Sub-Score",
    content: `
      <div id="slide_6" class="content-block hidden">
        Addresses the issuer’s ability to extract additional value via fees and spread increases
        <ul>
            <li>
                <span class="bold">Empirical inputs:</span> MFN* provisions (sunset, yield protection, and carve-out caps);
                financial covenants (incurrence tests / maintenance tests); portability; and call provisions
            </li>
            <li><span class="bold">Qualitative inputs:</span> Amendments Quality Score</li>
        </ul>
        <br>
        <span class="red_star">*</span> “MFN” or “most favored nation” provisions are designed to give lenders some degree of pricing
        protection if the company issues another tranche of debt at a higher price
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Liquidity Protection Sub-Score',
    content: `
      <div id="slide_7" class="content-block hidden">
        Addresses lenders’ ability to trade out of the credit in the secondary market
        <ul>
            <li><span class="bold">Qualitative inputs:</span> Transfer Provisions Quality Score</li>
        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Reporting Protection Sub-Score',
    content: `
      <div id="slide_8" class="content-block hidden">
        Addresses lenders’ ability to regularly monitor the financial health and business activities of the borrower
        <ul>
            <li><span class="bold">Qualitative inputs:</span> Reporting Quality Score</li>
        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Junior Debt Prepayments Protection Sub-Score',
    content: `
      <div id="slide_9" class="content-block hidden">
        Measures how well the document protects senior secured lenders’ right to be prepaid ahead of junior lien, unsecured, and/or subordinated creditors
        <ul>
            <li><span class="bold">Empirical inputs: </span>Asset sale sweep step-down; restricted payment cap; and junior debt prepayments cap</li>
            <li><span class="bold">Qualitative inputs: </span>Builder Basket Quality Score and Junior Debt Prepayments Quality Score</li>
        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Quality Scores',
    content: `
      <div id="slide_10" class="content-block hidden">
        <ul>
            <li>
                <span class="bold">EBITDA Adjustment Definition Quality Score: </span>
                Measures how narrowly the document limits a borrower’s ability to adjust EBITDA
            </li>
            <li>
                <span class="bold">Builder Basket Quality Score: </span> Measures how tightly the document restricts a
                borrower’s build capacity for restricted payments, to invest in unrestricted subsidiaries, or repay junior debt
            </li>
            <li><span class="bold">Amendments Quality Score: </span> Measures how easily the borrower can make changes to the document that are adverse to the lenders</li>
            <li>
                <span class="bold">Mandatory Prepayments Quality Score:</span>
                Measures the flexibility the borrower has to avoid using asset sale proceeds
                or excess cash flow to prepay the term loans and instead apply such amounts for other purposes
            </li>
            <li>
                <span class="bold">Junior Debt Prepayments Quality Score: </span> Measures how easily
                the borrower can prepay junior lien, unsecured, and/or subordinated creditors ahead of lenders
            </li>
            <li><span class="bold">Structural Subordination Quality Score:  </span> Measures how much debt of third party creditors can sit closer to the assets </li>
            <li><span class="bold">Reporting Quality Score: </span> Measures how often lenders receive financial statements and other information</li>
            <li><span class="bold">Transfer Provisions Quality Score: </span> Measures how easily lenders can trade out of the credit</li>
        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Yard-Sticks and Trends',
    content: `
      <div id="slide_11" class="content-block hidden">
        <ul>
            <li>The scores are designed to apply to the <span class="bold">post-2008 loan market</span></li>
            <li>Covenant Review modeled for the post-crisis era document</li>
            <li>Yard-sticks are set</li>
            <li>Scores will move up and down the scale as deal-making changes in response to market technical conditions</li>
            <li>
                Up-to-date spreadsheet of all US Documentation Scores can be found at:
                <a target="_blank" href="https://covenantreview.com/clientportal/covenantscores">https://covenantreview.com/clientportal/covenantscores</a></li>
        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Initial Data Set',
    content: `
      <div id="slide_12" class="content-block hidden">
        <ul>
            <li>Backfill: Roughly 185 of the largest senior secured institutional loans in Europe</li>
            <li>On-going Coverage: Beginning January 2019, all senior secured institutional European Loans in Covenant Review’s sample</li>
            <li>Contact us for the most recent list of names</li>
        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring: Histogram For Composite Scores',
    content: `
      <div id="slide_13" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide13.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Histogram For Collateral Protection Sub-Scores',
    content: `
      <div id="slide_14" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide14.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Histogram For Default Protection Sub-Scores',
    content: `
      <div id="slide_15" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide15.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Histogram For Lenders’ Repricing Protection Sub-Scores',
    content: `
      <div id="slide_16" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide16.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Histogram For Liquidity Protection Sub-Scores',
    content: `
      <div id="slide_17" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide17.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Histogram For Reporting Protection Sub-Scores',
    content: `
      <div id="slide_18" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide18.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Histogram For JDP Protection Sub-Scores',
    content: `
      <div id="slide_19" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide19.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Rolling LTM Average Composite Scores',
    content: `
      <div id="slide_20" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide20.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Rolling L3M Average Composite Scores',
    content: `
      <div id="slide_21" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide21.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Rolling LTM Average Composite Scores US vs Europe',
    content: `
      <div id="slide_22" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide22.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Rolling L3M Average Composite Scores US vs Europe',
    content: `
      <div id="slide_23" class="content-block hidden">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/europe/slide23.png">
      </div>
    `,
  },
  {
    title: 'Further Information',
    content: `
      <div id="slide_24" class="content-block hidden">
        Documentation Scoring Contacts
        <ul>
            <li>Steve Miller, Head of LevFin Intelligence Group, Fitch Solutions, 212-716-5782, <a href="mailto:smiller@covenantreview.com">smiller@covenantreview.com</a></li>
            <li>Jane Gray, Head of Covenant Review Europe, 0207 469 0989, <a href="mailto:jgray@covenantreview.com">jgray@covenantreview.com</a></li>
            <li>Jonathan Blau, Quantitative Consultant to Covenant Review, <a href="mailto:jblau@covenantreview.com">jblau@covenantreview.com</a></li>
        </ul>
        For general information and sample reports, email <a href="mailto:info@covenantreview.com">info@covenantreview.com</a>.
        <br>
        Covenant Review is a Fitch Solutions company.
        <br>
        See <a href="https://www.fitchsolutions.com">www.fitchsolutions.com </a> for more corporate information.&nbsp;
      </div>
    `,
  },
  {
    title: 'Disclaimers',
    content: `
      <div id="slide_25" class="content-block hidden">
        All content is copyright 2020 by Covenant Review, LLC.&nbsp; The recipient of this document may not
        redistribute or republish any of the information contained herein,
        in part or whole, without the express written permission of Covenant Review, LLC.&nbsp;
        The use of this report is further limited as described in the subscription agreement between Covenant Review, LLC and the subscriber.
        <br><br>
        The information contained herein is intended to generally describe certain market trends
        and/or covenant features based on certain credits analyzed by Covenant Review and does
        not necessarily reflect the entirety of the relevant markets.&nbsp;
        The information contained herein is not comprehensive, is not confidential
        to any person or entity, and should not be treated as a substitute for professional
        advice in any specific situation.&nbsp; Covenant Review, LLC makes no warranty, express or
        implied, as to the fitness of the information contained herein for any particular purpose.&nbsp;
        If you require legal or other expert advice, you should seek the services of a qualified attorney or
        investment professional.&nbsp; Covenant Review, LLC does not render, and nothing in this report constitutes,
        legal or investment advice, and recipients of this information will not be treated or considered by Covenant Review,
        LLC as clients or customers except as described in a subscription agreement between Covenant Review, LLC and the subscriber.&nbsp;
        Any covenants discussed herein may be based on those presented in preliminary documentation, and the covenants published in the
        final documentation may differ.&nbsp; The reader should be aware that the final interpretation of any bond indenture, credit agreement,
        security or guarantee agreement, or other bond or loan documents, will generally be determined
        by the issuer or its counsel, or in certain circumstances, by a court or administrative body.
      </div>
    `,
  },
];

export const DOC_SCORE_US_FILES = [
  {
    title: 'Large Cap and Middle Market Document Scores',
    extension: 'xlsx',
    url: '/api/common/v1/media/doc_scores/public/us_large_cap_middle_market_document_scores.xlsx',
  },
  {
    title: 'Document Scores FAQ',
    extension: 'pdf',
    url: '/api/common/v1/media/doc_scores/public/us_doc_scores_faq.pdf',
  },
  {
    title: 'Document Scores Description',
    extension: 'pdf',
    url: '/api/common/v1/media/doc_scores/public/us_doc_score_description.pdf',
  },
  {
    title: 'All Document Scores with LoanX ID',
    extension: 'xlsx',
    url: '/api/common/v1/media/doc_scores/private/loanx/na/us_large_cap_middle_market_document_scores_loan_x.xlsx',
    permission: PermissionEnum.COVENANTS_DOC_SCORES_LOANX_NA,
  },
  {
    title: 'All Document Scores with CUSIP',
    extension: 'xlsx',
    url: '/api/common/v1/media/doc_scores/private/cusip/us_large_cap_middle_market_document_scores_cusip.xlsx',
    permission: PermissionEnum.COVENANTS_DOC_SCORES_CUSIP_NA,
  },
];

export const DOC_SCORE_EU_FILES = [
  {
    title: 'All EU Document Scores',
    extension: 'xlsx',
    url: '/api/common/v1/media/doc_scores/public/eu_all_scored_deals.xlsx',
  },
  {
    title: 'All EU Document Scores with LoanX ID',
    extension: 'xlsx',
    url: '/api/common/v1/media/doc_scores/private/loanx/eu/eu_all_scored_deals_loanx.xlsx',
    permission: PermissionEnum.COVENANTS_DOC_SCORES_LOANX_EU,
  },
  {
    title: 'Document Scores Description',
    extension: 'pdf',
    url: '/api/common/v1/media/doc_scores/public/eu_doc_score_description.pdf',
  },
];

export const DOC_SCORE_US_SLIDES = [
  {
    active: true,
    title: 'Documentation Scoring Overview',
    content: `
      <div id="slide_1">
        <ul>
            <li>Goal: Measure the strength of the document to protecting lenders’ position</li>
            <li>Format: 1 (strongest) to 5 (weakest) scale with pluses and minuses applied for more precision</li>
            <li>Scores: CR will provide one overarching Composite Score that is derived from three Sub-Scores,
                based on a proprietary weighting scale</li>
            <li>
                Sub-scores:
                <ul>
                    <li>Collateral Protection</li>
                    <li>Default Protection</li>
                    <li>Lender’s Repricing Optionality</li>
                </ul>
            </li>
            <li>Coverage: Covenant Review will provide Documentation Scores
                for preliminary and final version of U.S. First-Lien Institutional loans in its data sample</li>
            <li>Note: Documentation Scores address the strength of the document to protect lenders.
                They are not meant to indicate recovery or default probabilities based on a borrower’s
                pro forma balance sheet/cash flow statement or financial performance over time</li>

        </ul>
    </div>
    `,
  },
  {
    title: 'Documentation Scoring Overview: Definitions',
    content: `
      <div id="slide_2">
        The score, sub-scores and qualitative scores will be expressed as follows:
        <ul>
            <li>1--Most Protective</li>
            <li>2--Fairly Protective</li>
            <li>3--Flexible</li>
            <li>4--Deficient</li>
            <li>5--Seriously Deficient</li>
        </ul>
        To augment these scores, Covenant Review will modify Scores that fall in
        between the main categories with pluses and minus, resulting in a 13-point
        scale: 1, 1-, 2+, 2, 2-, and so forth to 5 (there will be no 1+ or 5-)

    </div>
    `,
  },
  {
    title: 'Documentation Scoring Overview: Method',
    content: `
      <div id="slide_3">
          Each Score will be a product of multiple inputs comprising:
          <ul>
              <li>
                  Qualitative Scores for key document categories that cannot be measured only on an empirical basis:
                  <ul>
                      <li>EBITDA Adjustment Definition Quality Score</li>
                      <li>Mandatory Prepayment Quality Score</li>
                      <li>Amendment Quality Score</li>
                      <li>Builder Basket Quality Score</li>
                  </ul>
              </li>
              <li>Empirical data, such as free-and-clear (F&amp;C) tranche size as a percentage of EBITDA,
                  leakage of assets from the collateral pool, basket caps/growers, portability, MFN carve-outs, etc.</li>
              <li>Attorney Judgment: The scores are calibrated by qualitative assessments from CR’s team of legal analysts,
                  all of whom are seasoned attorneys with “Big Law” experience crafting levfin documents
              </li>
          </ul>
      </div>
    `,
  },
  {
    title: 'Sub-Scores Overview: Collateral Protection',
    content: `
      <div id="slide_4">
          The Collateral Protection Sub-Score is the most heavily weighted element in CR’s Composite Score because it addresses
          the paramount purpose of the credit agreement: keeping lenders’ recovery values high.
          <strong>
              The score, however, does not assess the loss/recovery risk of the deal based on the
              pro forma financials, or the issuer’s ongoing performance. It’s only meant as a comment
              on the borrower’s ability to erode lenders’ collateral claim via leakage, or adding additional
              pari passu debt to its balance sheet, without getting lender approval.
          </strong>
          <br>
          This Sub-Score takes into account the following criteria based on a proprietary weighting scale:
          <br>
          <ul>
              <li>Empirical inputs include: F&amp;C hard-cap amount as a percent of
                  EBITDA, F&amp;C grower percent, cap on investments in unrestricted subsidiaries,
                  leakage of assets outside the credit, pass-through investment basket (aka J Crew Trapdoor provision),
                  asset sales sweep step-down, reinvestment rights, inside maturity carve-out
              </li>
              <li>Qualitative inputs: Adjusted EBITDA Quality Score, Mandatory Prepayment Quality Score</li>
          </ul>
      </div>
    `,
  },
  {
    title: 'Sub-Scores Overview: Default Protection',
    content: `
      <div id="slide_5">
          This Sub-Score addresses the ability of issuers to add debt to the balance sheet and, thereby,
          increase the issuer’s default risk profile. It does not, however, assess the default risk of the
          deal based on the pro forma financials or the issuer’s on-going performance. It’s only meant as a
          comment on the borrower’s ability to add debt to its balance sheet and increase default probability
          after the loan is originated without getting lender approval.
          <br>
          This Sub-Score takes into account the following criteria based on a proprietary weighting scale:
          <br>
          <ul>
              <li>Empirical inputs include: General debt purpose cap/grower (inclusive of all debt capacity), restricted payment cap/grower</li>
              <li>Qualitative inputs: Adjusted EBITDA Quality Score, Builder Basket Quality Score</li>
          </ul>
      </div>
    `,
  },
  {
    title: "Sub-Scores Overview: Lenders' Repricing Optionality",
    content: `
      <div id="slide_6">
          This Sub-Score address the lenders’ ability to extract additional value via
          fees and spread increases if the issuer either falls into distress or takes an action
          (e.g., a recap, refinancing, or sale of the business). Given the proliferation of covenant-lite,
          lenders’ rights here are significantly curtailed compared with those of years past when tight maintenance
          tests were de rigueur. This Sub-Score takes into account the following criteria based on a proprietary weighting scale:
          <ul>
              <li>Empirical inputs: MFN provisions (sunset, yield protection, carve-out caps),
                  financial covenants (incurrence tests/maintenance tests), portability, call provisions
              </li>
              <li>Qualitative inputs:  Amendments Quality Score</li>
          </ul>
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Initial Data Set',
    content: `
      <div id="slide_7">
          <ul>
              <li>Backfill: 150 of the largest first-lien institutional loans in the Credit Suisse Leveraged Loan Index</li>
              <li>On-going Coverage: Beginning September 2018, all first-lien, large-corp., institutional U.S. Loans in Covenant Review’s sample</li>
              <li>Contact us for the most recent list of names</li>
          </ul>
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Histogram For Composite Scores',
    content: `
      <div id="slide_8">
          <img class="graphic" src="https://covenantreview.com/images/cov-scores/slide8.png">
      </div>
    `,
  },
  {
    title: 'Histogram For Collateral Protection Sub-Scores',
    content: `
      <div id="slide_9">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/slide9.png">
      </div>
    `,
  },
  {
    title: 'Histogram For Default Protection Sub-Scores',
    content: `
      <div id="slide_10">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/slide10.png">
      </div>
    `,
  },
  {
    title: "Histogram For Lenders' Repricing Optionality Sub-Scores",
    content: `
      <div id="slide_11">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/slide11.png">
      </div>
    `,
  },
  {
    title: 'Rolling LTM Average Composite Scores',
    content: `
      <div id="slide_12">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/slide12.png">
      </div>
    `,
  },
  {
    title: 'Rolling L3M Average Composite Scores',
    content: `
      <div id="slide_13">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/slide13.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Rolling LTM Averages',
    content: `
      <div id="slide_14">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/slide14.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Rolling L3M Averages',
    content: `
      <div id="slide_15">
        <img class="graphic" src="https://covenantreview.com/images/cov-scores/slide15.png">
      </div>
    `,
  },
  {
    title: 'Documentation Scoring: Key U.S. Contacts',
    content: `
      <div id="slide_16">
        <ul>
            <li>Steve Miller, Head of LevFin Intelligence Group, Fitch Solutions, 212-716-5782, <a href="mailto:smiller@covenantreview.com">smiller@covenantreview.com</a></li>
            <li>Anthony Canale, Global Head of Covenant Review Legal Research, 212-716-5784, <a href="mailto:acanale@covenantreview.com">acanale@covenantreview.com</a></li>
            <li>Jessica Reiss, Head of Covenant Review U.S. Loan Research, 212-716-5798, <a href="mailto:jreiss@covenantreview.com">jreiss@covenantreview.com</a></li>
            <li>Jonathan Blau, Quantitative Consultant to Covenant Review, <a href="mailto:jblau@covenantreview.com">jblau@covenantreview.com</a></li>
        </ul>
        For more information of Covenant Review’s products and services, please contact Manish Aggarwal at 212-716-5791, <a href="mailto:maggarwal@covenantreview.com">maggarwal@covenantreview.com</a>
      </div>
    `,
  },
  {
    title: 'Disclaimers',
    content: `
      <div id="slide_17">
        All content is copyright 2021 by Covenant Review, LLC.&nbsp; The recipient of this document may not redistribute or republish any of the information contained herein,
        in part or whole, without the express written permission of Covenant Review, LLC.&nbsp; The use of this report is further limited as described
        in the subscription agreement between Covenant Review, LLC and the subscriber.
        <br><br>
        The information contained herein is intended to generally describe certain market trends and/or covenant features based on certain credits analyzed by Covenant Review and does
        not necessarily reflect the entirety of the relevant markets.&nbsp;The information contained herein is not comprehensive, is not confidential to any person or entity,
        and should not be treated as a substitute for professional advice in any specific situation.&nbsp; Covenant Review, LLC makes no warranty, express or implied, as to the
        fitness of the information contained herein for any particular purpose.&nbsp; If you require legal or other expert advice, you should seek the services of a qualified
        attorney or investment professional.&nbsp; Covenant Review, LLC does not render, and nothing in this report constitutes, legal or investment advice,
        and recipients of this information will not be treated or considered by Covenant Review, LLC as clients or customers except as described in
        a subscription agreement between Covenant Review, LLC and the subscriber.&nbsp; Any covenants discussed herein may be based on those presented
        in preliminary documentation, and the covenants published in the final documentation may differ.&nbsp; The reader should be aware that the
        final interpretation of any bond indenture, credit agreement, security or guarantee agreement, or other bond or loan documents,
        will generally be determined by the issuer or its counsel, or in certain circumstances, by a court or administrative body.
      </div>
    `,
  },
];

const LOAN_COMPARE_MAPPINGS = [
  { key: 'tranche_type', value: 'Tranche Type', group: 'Transaction Fundamentals' },
  { key: 'Facility Tranche size', value: 'Term Loan Size ($ Millions)', group: 'Transaction Fundamentals' },
  { key: 'Facility Revolver Size', value: 'Revolver Size ($ Millions)', group: 'Transaction Fundamentals' },
  { key: 'Facility Price talk Current', value: 'Spread', group: 'Transaction Fundamentals' },
  { key: 'Facility Floor Current', value: 'Floor', group: 'Transaction Fundamentals' },
  { key: 'Facility OID Current', value: 'Price', group: 'Transaction Fundamentals' },
  { key: 'Facility Yield to maturity Current', value: 'YTM', group: 'Transaction Fundamentals' },
  { key: 'Facility Yield to maturity - 3 year Current', value: 'YTM - 3 year', group: 'Transaction Fundamentals' },
  { key: 'Facility Call Type', value: 'Call Type', group: 'Transaction Fundamentals' },
  { key: 'Facility Call Months', value: 'Call Term (Months)', group: 'Transaction Fundamentals' },
  { key: 'Accordion Free & clear Hard cap', value: 'Free & Clear Hard Cap ($ Millions)', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Soft cap', value: 'Free & Clear Grower %', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Soft cap type', value: 'Free & Clear Grower Type', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Ratio level 1', value: 'Free & Clear Ratio Level 1', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Ratio name 1', value: 'Free & Clear Ratio Name 1', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Ratio level 2', value: 'Free & Clear Ratio Level 2', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Ratio name 2', value: 'Free & Clear Ratio Name 2', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Ratio level 3', value: 'Free & Clear Ratio Level 3', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Ratio name 3', value: 'Free & Clear Ratio Name 3', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Inside maturity hard cap', value: 'Inside Maturity Hard Cap ($ Millions)', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion MFN Hard cap', value: 'MFN Hard Cap ($ Millions)', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion MFN Basis points', value: 'MFN Yield Protection', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion MFN Sunset months', value: 'MFN Sunset (months)', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion MFN Free & clear inclusion required', value: 'Free & Clear Incurs MFN', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Free & clear Reclassification', value: 'Reclassification', group: 'Incremental Tranche (C = closing)' },
  { key: 'Amendments LIBOR', value: 'LIBOR Succession', group: 'Incremental Tranche (C = closing)' },
  { key: 'Amendments LIBOR Category', value: 'LIBOR Succession Category', group: 'Incremental Tranche (C = closing)' },
  { key: 'Accordion Synergies / cost savings Soft cap Uncapped', value: 'Synergies & Cost Savings Cap', group: 'EBITDA Adjustment Restrictions' },
  { key: 'Accordion Synergies / cost savings Realized time period', value: 'Realized Time Period After Closing', group: 'EBITDA Adjustment Restrictions' },
  { key: 'Accordion Synergies / cost savings Realized actions w/in period', value: 'Realized Action w/in Period After Closing', group: 'EBITDA Adjustment Restrictions' },
  { key: 'Accordion Synergies / cost savings Realized after action taken', value: 'Realized After Action Taken', group: 'EBITDA Adjustment Restrictions' },
  { key: 'Accordion Synergies / cost savings Business optimization', value: 'Restructuring / Business Optimization', group: 'EBITDA Adjustment Restrictions' },
  { key: 'Builder basket Starter Hard cap', value: 'Starter Base Amount ($ Millions)', group: 'Builder Basket' },
  { key: 'Builder basket Starter Soft cap', value: 'Starter Grower %', group: 'Builder Basket' },
  { key: 'Builder basket Starter Soft cap type', value: 'Starter Grower type', group: 'Builder Basket' },
  { key: 'Builder basket Starter CNI', value: 'Starter CNI', group: 'Builder Basket' },
  { key: 'Builder basket Starter ECF', value: 'Starter ECF', group: 'Builder Basket' },
  { key: 'Builder basket Starter Unswept asset sale proceeds', value: 'Builds from unswept asset sale proceeds', group: 'Builder Basket' },
  { key: 'Debt Key metrics Hard cap', value: 'General purpose debt', group: 'Day-One Capacity ($ Millions)' },
  { key: 'Investments Key metrics Hard cap', value: 'Unrestricted subsidiary investments', group: 'Day-One Capacity ($ Millions)' },
  { key: 'Restricted payments Key metrics Hard cap', value: 'Restricted payments', group: 'Day-One Capacity ($ Millions)' },
  { key: 'Debt Key metrics Hard cap turns', value: 'General purpose debt', group: 'Day-One Capacity (% of EBITDA)' },
  { key: 'Investments Key metrics Hard cap turns', value: 'Unrestricted subsidiary investments', group: 'Day-One Capacity (% of EBITDA)' },
  { key: 'Restricted payments Key metrics Hard cap turns', value: 'Restricted payments', group: 'Day-One Capacity (% of EBITDA)' },
  { key: 'Debt General basket Hard cap total', value: 'Debt', group: 'General Basket Hard Caps ($ Millions)' },
  { key: 'Liens General basket Hard cap total', value: 'Liens', group: 'General Basket Hard Caps ($ Millions)' },
  { key: 'Restricted payments General basket Hard cap total', value: 'Restricted Payments', group: 'General Basket Hard Caps ($ Millions)' },
  { key: 'Investments General basket Hard cap total', value: 'Investments', group: 'General Basket Hard Caps ($ Millions)' },
  { key: 'Negative Covenants Soft cap type', value: 'Grower Type', group: 'General Basket Growers (%)' },
  { key: 'Debt General basket Soft cap total', value: 'Debt', group: 'General Basket Growers (%)' },
  { key: 'Liens General basket Soft cap total', value: 'Liens', group: 'General Basket Growers (%)' },
  { key: 'Restricted payments General basket Soft cap total', value: 'Restricted Payments', group: 'General Basket Growers (%)' },
  { key: 'Investments General basket Soft cap total', value: 'Investments', group: 'General Basket Growers (%)' },
  { key: 'Investments Passthrough Exists', value: 'Passthrough', group: 'Carveouts' },
  { key: 'Events of default Change of control Portability', value: 'Portability', group: 'Carveouts' },
  { key: 'Reported EBITDA', value: 'Reported EBITDA', group: 'Credit Stats ($ Millions)' },
  { key: 'Pro forma adjusted EBITDA', value: 'Pro Forma Adjusted EBITDA', group: 'Credit Stats ($ Millions)' },
  { key: 'Synergies cost savings', value: 'Synergies & Cost Savings Addbacks', group: 'Credit Stats ($ Millions)' },
  { key: 'Adj additional', value: 'Additional Adjustments', group: 'Credit Stats ($ Millions)' },
  { key: 'Adj to reported', value: 'Reported EBITDA Adjustment Percentage', group: 'Credit Stats ($ Millions)' },
  { key: 'Adj to pfadj', value: 'PF Adj. EBITDA Adjustment Percentage', group: 'Credit Stats ($ Millions)' },
  { key: 'Sources_Equity contribution total', value: 'Total Equity Contribution', group: 'Credit Stats ($ Millions)' },
  { key: 'Equity contribution total PF adj', value: 'Total Equity Contribution (% of PF Adj. EBITDA)', group: 'Credit Stats ($ Millions)' },
  { key: 'Uses_Purchase price', value: 'Purchase Price', group: 'Credit Stats ($ Millions)' },
  { key: 'Purchase price PF adj', value: 'Purchase Price (% of PF Adj. EBITDA)', group: 'Credit Stats ($ Millions)' },
  { key: 'Closing Gross first lien leverage', value: 'Gross First Lien Leverage Ratio', group: 'Adjusted Leverage at Close' },
  { key: 'Closing Net first lien leverage', value: 'Net First Lien Leverage Ratio', group: 'Adjusted Leverage at Close' },
  { key: 'Closing Gross secured leverage', value: 'Gross Secured Leverage Ratio', group: 'Adjusted Leverage at Close' },
  { key: 'Closing Net secured leverage', value: 'Net Secured Leverage Ratio', group: 'Adjusted Leverage at Close' },
  { key: 'Closing Gross total leverage', value: 'Gross Total Leverage Ratio', group: 'Adjusted Leverage at Close' },
  { key: 'Closing Net total leverage', value: 'Net Total Leverage Ratio', group: 'Adjusted Leverage at Close' },
  { key: 'Closing Gross first lien leverage Accordion', value: 'Gross First Lien Leverage Ratio', group: 'Adjusted Leverage at Close through the Free & Clear' },
  { key: 'Closing Net first lien leverage Accordion', value: 'Net First Lien Leverage Ratio', group: 'Adjusted Leverage at Close through the Free & Clear' },
  { key: 'Closing Gross secured leverage Accordion', value: 'Gross Secured Leverage Ratio', group: 'Adjusted Leverage at Close through the Free & Clear' },
  { key: 'Closing Net secured leverage Accordion', value: 'Net Secured Leverage Ratio', group: 'Adjusted Leverage at Close through the Free & Clear' },
  { key: 'Closing Gross total leverage Accordion', value: 'Gross Total Leverage Ratio', group: 'Adjusted Leverage at Close through the Free & Clear' },
  { key: 'Closing Net total leverage Accordion', value: 'Net Total Leverage Ratio', group: 'Adjusted Leverage at Close through the Free & Clear' },
  { key: 'Mandatory prepayments ECF Initial', value: 'ECF Sweep Initial', group: 'Sweeps' },
  { key: 'Mandatory prepayments ECF Ratio name', value: 'ECF Sweep Ratio Type', group: 'Sweeps' },
  { key: 'Mandatory prepayments ECF Step 1 percent', value: 'ECF Sweep Step-down 1', group: 'Sweeps' },
  { key: 'Mandatory prepayments ECF Step 1 level', value: 'ECF Sweep Step-down 1 Ratio', group: 'Sweeps' },
  { key: 'Mandatory prepayments ECF Step 2 percent', value: 'ECF Sweep Step-down 2', group: 'Sweeps' },
  { key: 'Mandatory prepayments ECF Step 2 level', value: 'ECF Sweep Step-down 2 Ratio', group: 'Sweeps' },
  { key: 'Mandatory prepayments Asset sales Stepdown exists', value: 'Asset Sales Step-down', group: 'Sweeps' },
  { key: 'Mandatory prepayments Asset sales Reinvestment period', value: 'Asset Sales Reinvestment Period (months)', group: 'Sweeps' },
  { key: 'Mandatory prepayments Asset sales Reinvestment extension', value: 'Asset Sales Reinvestment Extension (months)', group: 'Sweeps' },
  { key: 'Financial covenant Springing trigger Cov-lite', value: 'Cov-lite', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Initial level 1', value: 'Springing Trigger 1 Initial Level', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Ratio name 1', value: 'Springing Trigger 1 Ratio', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Threshold 1', value: 'Springing Trigger 1 Threshold', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Initial level 2', value: 'Springing Trigger 2 Initial Level', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Ratio name 2', value: 'Springing Trigger 2 Ratio', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Threshold 2', value: 'Springing Trigger 2 Threshold', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Initial level 3', value: 'Springing Trigger 3 Initial Level', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Ratio name 3', value: 'Springing Trigger 3 Ratio', group: 'Financial covenant' },
  { key: 'Financial covenant Springing trigger Threshold 3', value: 'Springing Trigger 3 Threshold', group: 'Financial covenant' },
  { key: 'Financial covenant Equity cure', value: 'Equity Cure Analysis', group: 'Financial covenant' },
  { key: 'Definitions Net first lien leverage', value: 'Net first lien leverage ratio', group: 'Financial covenant' },
  { key: 'Definitions Net secured leverage', value: 'Net secured leverage ratio', group: 'Financial covenant' },
  { key: 'Definitions Net total leverage', value: 'Net total leverage ratio', group: 'Financial covenant' },
  { key: 'Definitions Interest coverage', value: 'Interest coverage ratio', group: 'Financial covenant' },
  { key: 'Definitions Fixed charge coverage', value: 'Fixed charge coverage ratio', group: 'Financial covenant' },
  { key: 'Scoring Composite Score', value: 'Composite', group: 'Documentation Scores (1 = most protective to 5 = seriously deficient)' },
  { key: 'Scoring Collateral protection Score', value: 'Collateral Protection', group: 'Documentation Scores (1 = most protective to 5 = seriously deficient)' },
  { key: 'Scoring Default protection Score', value: 'Default Protection', group: 'Documentation Scores (1 = most protective to 5 = seriously deficient)' },
  { key: 'Scoring Lenders repricing Score', value: 'Lenders Repricing Optionality', group: 'Documentation Scores (1 = most protective to 5 = seriously deficient)' },
  { key: 'Overview Facilities', value: 'Facilities', group: 'Overview' },
  { key: 'Purpose Textblock', value: 'Use of proceeds', group: 'Overview' },
  { key: 'Overview Amortization', value: 'Amortization', group: 'Overview' },
  { key: 'Overview Pricing', value: 'Pricing', group: 'Overview' },
  { key: 'Overview Call protection Months', value: 'Call protection', group: 'Overview' },
  { key: 'Overview Guarantors', value: 'Guarantors', group: 'Overview' },
  { key: 'Overview Collateral', value: 'Collateral', group: 'Overview' },
  { key: 'Overview Intercreditor arrangements', value: 'Intercreditor arrangements', group: 'Overview' },
  { key: 'Debt General basket', value: 'General debt basket', group: 'Debt covenant' },
  { key: 'Debt Credit Facilities', value: 'Credit Facilities basket', group: 'Debt covenant' },
  { key: 'Debt Incremental equivalent', value: 'Incremental equivalent debt', group: 'Debt covenant' },
  { key: 'Debt Other credit facilities', value: 'Other credit facilities', group: 'Debt covenant' },
  { key: 'Debt New bond series', value: 'New bond series', group: 'Debt covenant' },
  { key: 'Debt Existing bond series', value: 'Existing bond series', group: 'Debt covenant' },
  { key: 'Debt Acquisition', value: 'Acquisition debt', group: 'Debt covenant' },
  { key: 'Debt Acquired', value: 'Acquired debt', group: 'Debt covenant' },
  { key: 'Debt Equity credit', value: 'Equity credit debt', group: 'Debt covenant' },
  { key: 'Debt Non loan party', value: 'Non-loan party debt', group: 'Debt covenant' },
  { key: 'Debt Foreign subsidiary', value: 'Foreign subsidiary debt', group: 'Debt covenant' },
  { key: 'Debt Letters of credit', value: 'Letters of credit and other credit support / working capital facilities', group: 'Debt covenant' },
  { key: 'Debt Guarantees of debt', value: 'Guarantees of / debt on behalf of joint ventures', group: 'Debt covenant' },
  { key: 'Debt Intercompany', value: 'Intercompany debt', group: 'Debt covenant' },
  { key: 'Debt Guarantees of permitted debt', value: 'Guarantees of permitted debt', group: 'Debt covenant' },
  { key: 'Debt Purchase money / capital lease obligations', value: 'Purchase money debt / capital lease obligations', group: 'Debt covenant' },
  { key: 'Debt Sale leasebacks', value: 'Attributable sale-leaseback debt', group: 'Debt covenant' },
  { key: 'Debt Receivables financings / securitizations', value: 'Receivables financings / securitizations', group: 'Debt covenant' },
  { key: 'Debt Scheduled / existing', value: 'Scheduled / existing debt', group: 'Debt covenant' },
  { key: 'Debt Reclassification', value: 'Debt reclassification', group: 'Debt covenant' },
  { key: 'Debt Ratio carveout', value: 'Ratio debt carveout', group: 'Debt covenant' },
  { key: 'Liens Ratio carveout', value: 'Ratio carveout', group: 'Liens covenant' },
  { key: 'Liens Ratio carveout Secures ratio debt', value: 'Liens securing the ratio debt carveout', group: 'Liens covenant' },
  { key: 'Liens Incremental equivalent', value: 'Liens securing incremental equivalent debt', group: 'Liens covenant' },
  { key: 'Liens Other credit facilities', value: 'Liens securing other credit facilities', group: 'Liens covenant' },
  { key: 'Liens New bonds', value: 'Liens securing new bonds', group: 'Liens covenant' },
  { key: 'Liens Existing bonds', value: 'Liens securing existing bonds', group: 'Liens covenant' },
  { key: 'Liens Non collateral', value: 'Liens on non-collateral assets', group: 'Liens covenant' },
  { key: 'Liens Credit Facilities', value: 'Liens securing the Credit Facilities basket', group: 'Liens covenant' },
  { key: 'Liens Acquisition', value: 'Liens securing acquisition debt', group: 'Liens covenant' },
  { key: 'Liens Acquired', value: 'Acquired liens', group: 'Liens covenant' },
  { key: 'Liens Non loan party', value: 'Liens on non-loan party assets', group: 'Liens covenant' },
  { key: 'Liens Foreign subsidiary', value: 'Liens on foreign subsidiary assets', group: 'Liens covenant' },
  { key: 'Liens Intercompany', value: 'Intercompany liens', group: 'Liens covenant' },
  { key: 'Liens Purchase money / capital lease obligations', value: 'Purchase money liens / liens securing capital leases', group: 'Liens covenant' },
  { key: 'Liens Sale leasebacks', value: 'Liens in connection with sale-leasebacks', group: 'Liens covenant' },
  { key: 'Liens Receivables financings / securitizations', value: 'Receivables financing / securitization liens', group: 'Liens covenant' },
  { key: 'Liens Scheduled / existing', value: 'Scheduled / existing liens', group: 'Liens covenant' },
  { key: 'Liens Reclassification', value: 'Lien reclassification', group: 'Liens covenant' },
  { key: 'Restricted payments Builder basket', value: 'General growth / builder basket', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Ratio carveout', value: 'Ratio carveout', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Separate general', value: 'Separate general basket', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Shared general', value: 'Shared general basket', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Annual dividends', value: 'Annual dividends basket', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Holdco debt', value: 'Restricted payments to fund interest on holdco debt', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Unrestricted subsidiary stock or debt', value: 'Distributions of unrestricted subsidiary stock or debt', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Post public offering dividends', value: 'Post-public offering dividends', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Disqualified or preferred stock', value: 'Dividends on disqualified or preferred stock', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Designated preferred stock refunding stock', value: 'Dividends on designated preferred stock / refunding stock', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Repurchase of employee director stock', value: 'Repurchase of employee / director stock', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Scheduled / existing', value: 'Scheduled restricted payments', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Equity credit', value: 'Equity credit restricted payments', group: 'Restricted payments covenant' },
  { key: 'Restricted payments Reclassification', value: 'Reclassification', group: 'Restricted payments covenant' },
  { key: 'Investments Builder basket', value: 'General growth / builder basket', group: 'Investments covenant' },
  { key: 'Investments Ratio carveout', value: 'Ratio carveout', group: 'Investments covenant' },
  { key: 'Investments Separate general', value: 'Separate general basket', group: 'Investments covenant' },
  { key: 'Investments Shared general', value: 'Shared general basket', group: 'Investments covenant' },
  { key: 'Investments Acquisitions', value: 'Permitted business acquisitions', group: 'Investments covenant' },
  { key: 'Investments Similar / related businesses', value: 'Investments in similar / related businesses', group: 'Investments covenant' },
  { key: 'Investments JVs', value: 'Investments in joint ventures', group: 'Investments covenant' },
  { key: 'Investments Unrestricted subsidiaries', value: 'Investments in unrestricted subsidiaries', group: 'Investments covenant' },
  { key: 'Investments Non loan party', value: 'Investments by non-loan parties', group: 'Investments covenant' },
  { key: 'Mandatory prepayments Reinvestments in useful assets', value: 'Reinvestments in useful assets with asset sale proceeds', group: 'Investments covenant' },
  { key: 'Investments Intercompany', value: 'Intercompany investments', group: 'Investments covenant' },
  { key: 'Investments Guarantees', value: 'Permitted guarantees', group: 'Investments covenant' },
  { key: 'Investments Receivables financings / securitizations', value: 'Investments for receivables financings / securitizations', group: 'Investments covenant' },
  { key: 'Investments Scheduled / existing', value: 'Scheduled / existing investments', group: 'Investments covenant' },
  { key: 'Investments Equity credit', value: 'Equity credit investments', group: 'Investments covenant' },
  { key: 'Investments Reclassification Textblock', value: 'Reclassification', group: 'Investments covenant' },
  { key: 'Junior debt prepayments Builder basket', value: 'General growth / builder basket', group: 'Junior debt prepayments covenant' },
  { key: 'Junior debt prepayments Ratio carveout', value: 'Ratio carveout', group: 'Junior debt prepayments covenant' },
  { key: 'Junior debt prepayments Separate general', value: 'Separate general basket', group: 'Junior debt prepayments covenant' },
  { key: 'Junior debt prepayments Prepayments near maturity', value: 'Prepayments near maturity', group: 'Junior debt prepayments covenant' },
  { key: 'Junior debt prepayments Equity credit', value: 'Equity credit prepayments', group: 'Junior debt prepayments covenant' },
  { key: 'Junior debt prepayments Refinancings', value: 'Permitted refinancings', group: 'Junior debt prepayments covenant' },
  { key: 'Junior debt prepayments Shared general', value: 'Shared general basket', group: 'Junior debt prepayments covenant' },
  { key: 'Junior debt prepayments Reclassification', value: 'Reclassification', group: 'Junior debt prepayments covenant' },
  { key: 'Asset sales General', value: 'General basket', group: 'Asset sales covenant' },
  { key: 'Asset sales Sale leasebacks', value: 'Sale-leasebacks', group: 'Asset sales covenant' },
  { key: 'Asset sales Non collateral', value: 'Sales of non-collateral assets', group: 'Asset sales covenant' },
  { key: 'Asset sales Unrestricted subsidiary equity / debt', value: 'Sales of unrestricted subsidiary equity / debt', group: 'Asset sales covenant' },
  { key: 'Asset sales Specified', value: 'Specified dispositions', group: 'Asset sales covenant' },
  { key: 'Asset sales Scheduled', value: 'Scheduled dispositions', group: 'Asset sales covenant' },
  { key: 'Asset sales Intercompany', value: 'Intercompany dispositions', group: 'Asset sales covenant' },
  { key: 'Asset sales De minimis', value: 'De minimis sales', group: 'Asset sales covenant' },
  { key: 'Asset sales Receivables financings', value: 'Sales of receivables for receivables financings', group: 'Asset sales covenant' },
  { key: 'Events of default Textblock', value: 'Events of default', group: 'Events of Default' },
  { key: 'Amendments Requisite lender consent', value: 'Requisite lender consent for amendments / waivers', group: 'Amendments, etc' },
  { key: 'Amendments Amend and extend', value: 'Amend and extend provisions', group: 'Amendments, etc' },
  { key: 'Amendments Replacement / refinancing', value: 'Replacement / refinancing provisions', group: 'Amendments, etc' },
  { key: 'Amendments Yankabank', value: 'Yank-a-bank provisions', group: 'Amendments, etc' },
  { key: 'Assignments and buybacks Open market', value: 'Open market assignments / loan buybacks', group: 'Assignments and buybacks' },
  { key: 'Assignments and buybacks Excluded / blacklisted assignees', value: 'Excluded / blacklisted assignees', group: 'Assignments and buybacks' },
  { key: 'Assignments and buybacks Borrower consent', value: 'Borrower consent', group: 'Assignments and buybacks' },
];

const loanCompareKeys = {};
const loanCompareGroups: string[] = [];

for (const item of LOAN_COMPARE_MAPPINGS) {
  loanCompareKeys[item.key] = item;

  if (loanCompareGroups.indexOf(item.group) === -1) {
    loanCompareGroups.push(item.group);
  }
}

export const LOAN_COMPARE_KEYS = loanCompareKeys;
export const LOAN_COMPARE_GROUPS = loanCompareGroups;

export const COVENANT_COMPARE_FIELDS = [
  'Entire Future Guarantors covenant',
  'Entire Debt Covenant',
  'General rule and Ratio debt paragraph(s)',
  'Permitted Debt list / carveouts',
  'Entire Liens covenant',
  'Permitted Liens definition',
  'Entire Restricted Payments covenant',
  'General Restricted Payments rule and basket build-up',
  'Restricted Payments carveouts',
  'Permitted Investment definition',
  'Entire Asset Sales covenant',
  'Asset Sales definition',
  'Entire Sale / Leaseback covenant',
  'Entire Mergers covenant',
  'Entire Affiliate Transactions covenant',
  'General rule',
  'Carveouts',
  'Entire Reports covenant',
  'Entire Change of Control Covenant',
  'Change of Control definition',
  'Related Definitions to Change of Control definition',
  'Sale of substantially all assets',
  'Beneficial ownership of voting stock',
  'Mergers',
  'Continuing directors',
  'Plan of liquidation or dissolution',
  'Other triggers',
  'Ratings condition and definitions related to the ratings condition?',
  'Entire equity claw provision',
  'Equity offering definition',
  'Free covenant(s)',
  'Definitions',
];

export const NON_SPONSORED = 'Non-Sponsored';
export const SPONSORS = 'sponsors';
